import { type PayloadAction, createReducer } from '@reduxjs/toolkit';

import { loadDomainFoldersSuccess } from './domainFolders.actions';
import type { ApiDomainFoldersResponse, DomainFoldersState } from './domainFolders.types';

const initialState: DomainFoldersState = {
    list: {},
};

export const domainFoldersReducer = createReducer(initialState, {
    [loadDomainFoldersSuccess.type]: (state, action: PayloadAction<ApiDomainFoldersResponse | undefined>) => {
        const domainFolders = action.payload;

        (domainFolders ?? []).forEach((folder) => {
            state.list[folder.home.toLowerCase()] = {
                __reduxTree: true,
                id: folder.home,
                name: folder.name,
                size: folder.size,
                mode: folder.mode,
                mode_bitmask: folder.mode_bitmask,
                home: folder.home,
                quota: folder.quota,
                tree: folder.tree,
                icon: '',
                href: '',
                text: '',
            };
        });
    },
});
